// import theme from "material-ui/styles/baseThemes/darkBaseTheme";

// theme.palette.borderColor = "#FFF";
// theme.palette.primary1Color = "#FFF";
// theme.palette.primary2Color = "#FFF";

// theme.palette.accent1Color = "#FFF";

// console.log(JSON.stringify(theme));

// export default theme;

const theme = {
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopDrawerMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56
  },
  fontFamily: "Roboto, sans-serif",
  borderRadius: 2,
  palette: {
    primary1Color: "#FFF",
    primary2Color: "#FFF",
    primary3Color: "#757575",
    accent1Color: "#FFF",
    accent2Color: "#f50057",
    accent3Color: "#ff80ab",
    textColor: "rgba(255, 255, 255, 1)",
    secondaryTextColor: "rgba(255, 255, 255, 0.7)",
    alternateTextColor: "#303030",
    canvasColor: "#303030",
    borderColor: "#FFF",
    disabledColor: "rgba(255, 255, 255, 0.3)",
    pickerHeaderColor: "rgba(255, 255, 255, 0.12)",
    clockCircleColor: "rgba(255, 255, 255, 0.12)"
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/user/theme.js